const state = {
    mobileNavIsShowing: false,
}

const getters = {
    mobileNavIsShowing: (state) => {
        return state.mobileNavIsShowing;
    },
}

const actions = {
    showMobileNav ({ commit, state }) {
        commit('SHOW_MOBILE_NAV');
    },

    hideMobileNav ({ commit, state }) {
        commit('HIDE_MOBILE_NAV');
    },

    toggleMobileNav ({ commit, state }) {
        if (state.mobileNavIsShowing) {
            commit('HIDE_MOBILE_NAV');
        } else {
            commit('SHOW_MOBILE_NAV');
        }
    },
}

const mutations = {
    SHOW_MOBILE_NAV (state) {
        state.mobileNavIsShowing = true;
    },

    HIDE_MOBILE_NAV (state) {
        state.mobileNavIsShowing = false;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
